"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _intents = require("@ux/intents");
var _intents2 = _interopRequireDefault(require("@site/pattern-library-utils/intents"));
// eslint-disable-next-line max-statements
var _default = exports.default = function () {
  // TODO: Remove this when the new intents are available.
  _intents2.default.create('@site/action/inverted', {
    styleProperties: [_intents.enums.properties.BACKGROUND_COLOR, _intents.enums.properties.FOREGROUND_COLOR]
  });

  // TODO: Remove this when the new intents are available.
  _intents2.default.create('@site/action/primary/inverted', {
    styleProperties: [_intents.enums.properties.BACKGROUND_COLOR, _intents.enums.properties.FOREGROUND_COLOR, _intents.enums.properties.BORDER_COLOR, _intents.enums.properties.BORDER_RADIUS]
  });
  _intents2.default.create('@site/action/primary/disabled', {
    styleProperties: [_intents.enums.properties.BACKGROUND_COLOR, _intents.enums.properties.FOREGROUND_COLOR, _intents.enums.properties.BORDER_COLOR, _intents.enums.properties.BORDER_RADIUS]
  });

  // TODO: Remove this when the new intents are available.
  _intents2.default.create('@site/action/secondary/inverted', {
    interactions: [_intents.enums.interactions.HOVERED],
    styleProperties: [_intents.enums.properties.BACKGROUND_COLOR, _intents.enums.properties.FOREGROUND_COLOR, _intents.enums.properties.BORDER_COLOR, _intents.enums.properties.BORDER_RADIUS]
  });
  _intents2.default.create('@site/action/secondary/disabled', {
    styleProperties: [_intents.enums.properties.BACKGROUND_COLOR, _intents.enums.properties.FOREGROUND_COLOR, _intents.enums.properties.BORDER_COLOR, _intents.enums.properties.BORDER_RADIUS]
  });

  // TODO: Remove this when the new intents are available.
  _intents2.default.siteActionInverted.backgroundColor = _intents2.default.ux.action.backgroundColor;
  _intents2.default.siteActionInverted.foregroundColor = _intents2.default.ux.actionPrimary.foregroundColor;
  _intents2.default.siteActionPrimaryDisabled.backgroundColor = _intents2.default.ux.controlVoid.foregroundColor;
  _intents2.default.siteActionPrimaryDisabled.borderColor = _intents2.default.ux.actionPrimary.borderColor;
  _intents2.default.siteActionPrimaryDisabled.foregroundColor = _intents2.default.ux.actionPrimary.foregroundColor;
  _intents2.default.siteActionPrimaryDisabled.borderRadius = _intents2.default.ux.actionPrimary.borderRadius;
  _intents2.default.siteActionSecondaryDisabled.backgroundColor = _intents2.default.ux.actionSecondary.backgroundColor;
  _intents2.default.siteActionSecondaryDisabled.borderColor = _intents2.default.ux.controlVoid.foregroundColor;
  _intents2.default.siteActionSecondaryDisabled.foregroundColor = _intents2.default.ux.controlVoid.foregroundColor;
  _intents2.default.siteActionSecondaryDisabled.borderRadius = _intents2.default.ux.actionSecondary.borderRadius;
  _intents2.default.siteActionPrimaryInverted.foregroundColor = _intents2.default.ux.actionPrimary.backgroundColor;
  _intents2.default.siteActionPrimaryInverted.backgroundColor = _intents2.default.ux.actionPrimary.foregroundColor;
  _intents2.default.siteActionPrimaryInverted.borderColor = _intents2.default.ux.actionPrimary.borderColor;
  _intents2.default.siteActionPrimaryInverted.borderRadius = _intents2.default.ux.actionPrimary.borderRadius;
  _intents2.default.siteActionSecondaryInverted.backgroundColor = _intents2.default.ux.actionSecondary.foregroundColor;
  _intents2.default.siteActionSecondaryInverted.borderColor = _intents2.default.ux.actionSecondary.backgroundColor;
  _intents2.default.siteActionSecondaryInverted.foregroundColor = _intents2.default.ux.actionSecondary.backgroundColor;
  _intents2.default.siteActionSecondaryInverted.borderRadius = _intents2.default.ux.actionSecondary.borderRadius;
  _intents2.default.siteActionSecondaryInvertedHovered.backgroundColor = _intents2.default.ux.actionSecondary.backgroundColor;
  _intents2.default.siteActionSecondaryInvertedHovered.borderColor = _intents2.default.siteActionSecondaryInverted.borderColor;
  _intents2.default.siteActionSecondaryInvertedHovered.borderRadius = _intents2.default.siteActionSecondaryInverted.borderRadius;
  _intents2.default.siteActionSecondaryInvertedHovered.foregroundColor = _intents2.default.ux.actionSecondary.foregroundColor;
  return _intents2.default;
}();